"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NavContext", {
    enumerable: true,
    get: function() {
        return NavContext;
    }
});
const _react = require("react");
const NavContext = /*#__PURE__*/ (0, _react.createContext)({});

//# sourceMappingURL=NavContext.js.map